import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { pushPage } from '@shared/actions';
import getShop from '@core/reducers/shop/selectors/getShop';
import setShop from '@core/reducers/shop/actions/setShop';
import trackProductClicked from '@conversion/tracking/actions/trackProductClicked';

import ProductCardContainer, {
  getProductCardProps,
} from './ProductCardContainer';

const mapStateToProps = createStructuredSelector({
  shop: getShop,
});

const mapDispatchToProps = {
  pushPage,
  setShop,
  trackProductClicked,
};

export { getProductCardProps };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductCardContainer);
